import styles from '../../maintenancerequestdetails.module.css';
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, InputLabel, MenuItem, Select } from "@mui/material";
import { UploadCloud, X } from "react-feather";
import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-smart-toaster';
import { useAuth0 } from "@auth0/auth0-react";
import { AddLogCallAPI } from '../../../../components/AddLogs';
import { useForm } from 'react-hook-form';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

const SummaryTab = ({ requestData, setRequestData, setSnackbarOpen, setSnackbarMsg, setLoading }) => {
    const { user, isAuthenticated } = useAuth0();
    const { getAccessTokenSilently } = useAuth0();
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(0);
    const [deleteType, setDeleteType] = useState(0);
    const [oldData, setOldData] = useState({ description: '', resolution: '' });
    const [newData, setNewData] = useState({ description: '', resolution: '' });
    const [charsLeft, setCharsLeft] = useState({ description: 200, resolution: 200 });
    const [isUpdate, setIsUpdate] = useState(false);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(1);
    const [carouselImages, setCarouselImages] = useState([]);

    const { handleSubmit, register, setValue } = useForm();

    useEffect(() => {
        if (requestData) {
            setOldData({ description: requestData?.description, resolution: requestData?.resolution ? requestData?.resolution : '' });
            setNewData({ description: requestData?.description, resolution: requestData?.resolution ? requestData?.resolution : '' });

            setValue('description', requestData?.description);
            setValue('resolution', requestData?.resolution);

            if (requestData?.description?.length) {
                setCharsLeft(prev => {
                    return { ...prev, description: 200 - requestData?.description?.length };
                })
            }
            if (requestData?.resolution?.length) {
                setCharsLeft(prev => {
                    return { ...prev, resolution: 200 - requestData?.resolution?.length };
                })
            }

            let reqImages = requestData?.images?.map(i => {
                if (i?.file_path.split('.').pop() === 'jpeg' || i?.file_path.split('.').pop() === 'jpg' || i?.file_path.split('.').pop() === 'png' || i?.file_path.split('.').pop() === 'svg') {
                    return i;
                }
                return null;
            });

            reqImages = reqImages?.filter(i => i !== null);

            setCarouselImages(reqImages);
        }
    }, [requestData, setValue]);

    useEffect(() => {
        if (oldData) {
            if (oldData?.description === newData?.description) {
                setIsUpdate(false);
            } else {
                setIsUpdate(true);
            }
        }
    }, [newData, oldData]);

    const deleteConfirm = async () => {
        setLoading(true);
        setOpenDeleteModal(false);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.delete(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/files/' + deleteId, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setRequestData(prev => {
                if (deleteType === 1) {
                    let images = prev?.resolve_images?.filter(i => i?.id !== deleteId);
                    return { ...prev, resolve_images: images };
                } else {
                    let images = prev?.images?.filter(i => i?.id !== deleteId);
                    return { ...prev, images: images };
                }
            });
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const fileHandler = async (e) => {
        let extErr = false;
        let sizeErr = false;
        let files = e.target.files;
        let allowedExtensionArr = ".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf".split(',');

        if (files.length > 0) {
            if (allowedExtensionArr.length > 0) {
                let fileName = files[0].name;
                let fileSize = files[0].size;
                let fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
                fileNameExt = '.' + fileNameExt;

                if (allowedExtensionArr.indexOf(fileNameExt) === -1) {
                    extErr = true;
                }

                if (fileSize >= 5242880) {
                    sizeErr = true;
                }
            }
        }

        if (extErr) {
            toast.error("File type is not allowed.");
            return false;
        }

        if (sizeErr) {
            toast.error("File size should not be greater than 5 MB.");
            return false;
        }

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        setLoading(true);

        let formData = new FormData();
        formData.append("image", files[0]);

        axios.post(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/files/upload', formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(response => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg('Files uploaded successfully.');

            setRequestData(prev => {
                let images = response.data.data.concat(prev?.images);
                return { ...prev, images: images };
            });
        }).catch(error => {
            setLoading(false);
        });
    }

    const onUpdate = async (data) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests/" + requestData?.id, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setRequestData(prev => {
                return { ...prev, description: response.data.data?.description, resolution: response.data.data?.resolution };
            });

            let logData = {
                title: "A maintenance request has been updated",
                description: [
                    "Name: " + response.data.data.title,
                    "Request number: " + response.data.data.request_no,
                    "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
                    "Tenant: " + response.data.data.tenant_name,
                ],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<>
        <div className={`${styles.FormAccoHeadSumm}`}>
            <p className={`${styles.FormAccoHeadTitle}`}>Request</p>
        </div>
        <form onSubmit={handleSubmit(onUpdate)}>
            <div className={`${styles.SummFormFull}`}>
                <p className={`${styles.SummFormLabel}`}>Maintenance Issue Description</p>
                <textarea name="description" ref={register} className={`${styles.formControlTextArea}`} maxLength={200} onChange={(e) => {
                    setCharsLeft(prev => {
                        return { ...prev, description: 200 - e.target.value?.length };
                    });

                    setNewData(prev => {
                        return { ...prev, description: e.target.value };
                    });
                }} disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1)}></textarea>
                <p className={`${styles.RemainingText}`}>{charsLeft?.description} {charsLeft?.description > 1 ? "characters" : "character"} remaining</p>
            </div>
            {isUpdate && <div>
                <button type='submit' className={`${styles.SummaryUpdateBU}`}>Update</button>
            </div>}
        </form>

        <div className={`${styles.BorderDivSumm}`}>
            <p className={`${styles.SummFormLabel}`}>Request Photos</p>

            <div className={`${styles.Row}`}>
                {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1) && <div className={`${styles.FileUpDuBUDiv}`}>
                    <label className={`${styles.TakePhoteBU}`} for="file-upload"><UploadCloud /> Upload Photo</label>
                    <p className={`${styles.UploadTextNew}`}>File size upto 5 MB. JPEG, JPG, PNG only</p>
                    <input id="file-upload" type="file" onChange={fileHandler} accept={".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf"} />
                </div>}
                <div className={`${styles.ReqPhotoSec}`}>
                    {requestData?.images?.map((item, index) => {
                        return (<div className={`${styles.SummFormSemiHalf}`}>
                            {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1) && <button onClick={(e) => { setOpenDeleteModal(true); setDeleteId(item?.id); setDeleteType(0); }}><X /></button>}
                            {((item?.file_path.split('.').pop() === 'doc' || item?.file_path.split('.').pop() === 'docx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                                <img src="/static/img/docIcon.png" alt='' />
                                <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                            </a> : ((item?.file_path.split('.').pop() === 'xls' || item?.file_path.split('.').pop() === 'xlsx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                                <img src="/static/img/excelIcon.png" alt='' />
                                <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                            </a> : ((item?.file_path.split('.').pop() === 'pdf') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                                <img src="/static/img/pdfIcon.png" alt='' />
                                <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                            </a> : <img src={item?.file_public_url} className={styles.UpIMG} alt="" onClick={(e) => { setLightboxOpen(true); setLightboxIndex(index); }} />)))}
                        </div>)
                    })}
                </div>
                {requestData?.images?.length === 0 && (<div className={`${styles.NoImgDiv}`}>
                    <img src="/static/img/no-photo.png" alt="" />
                </div>)}
            </div>
        </div>

        {requestData?.title === "Electrical/Mount Television" && <div className={`${styles.DisclaimerText}`}>
            <p><span>TV Mount Waiver Agreement</span><br />We recommend that the tenant be present in their unit during the TV mounting appointment to ensure the installation proceeds smoothly. Please be advised that the property management team and its contractors are <span>not liable for any damage to the TV or related equipment during or after installation.</span></p>
            <p>If adjustments or re-mounting are requested after the initial installation, a <span>$100 service fee</span> will apply. <br />By submitting this maintenance request, you acknowledge and agree to the terms of this waiver.</p>
            <p>Additionally, if the appointment cannot be completed for any reason such as missing parts, incorrect mounting instructions, or other issues that prevent installation, a <span>$100 service fee</span> will be required to reschedule the appointment.</p>
            <p>By submitting this maintenance request, you acknowledge that you have read and agree to these terms.</p>
            <FormControlLabel className={`${styles.FormCheckbox} FormCheckbox`}
                control={<Checkbox
                    checked
                    disabled
                />}
                label="I have read and agree to the terms of the TV Mount Waiver Agreement."
            />
        </div>}

        <div className={`${styles.DisclaimerText} ${styles.Blue}`}>
            <p>By submitting this request, you confirm that the information provided is accurate to the best of your knowledge. </p>
            <p><span>Service availability, estimated time, and charges may vary based on the issue</span>. Any additional work or cost will be communicated before proceeding.</p>
            <FormControlLabel className={`${styles.FormCheckbox} FormCheckbox`}
                control={<Checkbox
                    checked={parseInt(requestData?.is_tenant_timeslot) === 0}
                    disabled
                />}
                label="You authorize our service team to enter your apartment and carry out the request repair"
            />
            <FormControlLabel className={`${styles.FormCheckbox} FormCheckbox`}
                control={<Checkbox
                    checked={parseInt(requestData?.is_tenant_timeslot) === 1}
                    disable
                />}
                label="I would like to be present at home during the maintenance call. I will available during the following  time slot."
            />
            {parseInt(requestData?.is_tenant_timeslot) === 1 && <>
                <div className={`${styles.FormContentSelect} FormGroup`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Select Time*</InputLabel>
                        <Select
                            label="Select Time*"
                            value={requestData?.schedule_time}
                            disabled
                        >
                            <MenuItem value={requestData?.schedule_time}>{requestData?.schedule_time}</MenuItem>
                        </Select>
                    </FormControl>
                </div>
            </>}
        </div>

        <Dialog
            open={openDeleteModal}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setOpenDeleteModal(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">Are you sure you want to delete the image?<button onClick={(e) => setOpenDeleteModal(false)}><X /></button></DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">The image will be removed immediately.You can't undo this action.</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className="CancelPopupBU" onClick={(e) => deleteConfirm()}>Delete</Button>
                <Button className="SubmitPopupBU" onClick={(e) => setOpenDeleteModal(false)}>Cancel</Button>
            </DialogActions>
        </Dialog>

        <Lightbox
            open={lightboxOpen}
            close={() => setLightboxOpen(false)}
            index={lightboxIndex}
            carousel={{ finite: true, preload: 2, padding: "16px", spacing: "30%", imageFit: "contain" }}
            slides={carouselImages?.map(i => {
                if (i?.file_path.split('.').pop() === 'jpeg' || i?.file_path.split('.').pop() === 'jpg' || i?.file_path.split('.').pop() === 'png' || i?.file_path.split('.').pop() === 'svg') {
                    return { src: i?.file_public_url };
                }
                return null;
            })}
        />


    </>);
}

export default SummaryTab;